import Axios from "../utils/Axios";

export const getInventory = async () => {
  const response = await Axios.get("/inventory/");
  return response.data;
};

export const getInventoryVendor = async () => {
  const response = await Axios.get("/inventory/vendor");
  return response.data;
};

export const getInventoryItem = async (id) => {
  const response = await Axios.get(`/inventory/item/${id}`);
  return response.data;
};

export const getPartDropdownOptions = async () => {
  const response = await Axios.get("/inventory/dropdown-options");
  return response.data;
};

export const addInventory = async (formData) => {
  const response = await Axios.post("/inventory/add", formData);
  return response.data;
};

export const editInventory = async (id, formData) => {
  const response = await Axios.put(`/inventory/edit/${id}`, formData);
  return response.data;
};

export const deleteInventory = async (id) => {
  try {
    const response = await Axios.delete(`/inventory/delete/${id}`);
    return response.data;
  } catch (error: any) {
    // Capture Flask error message
    const errorMessage =
      error.response?.data?.error || "Failed to delete entry";
    throw new Error(errorMessage);
  }
};

export const getLocation = async () => {
  const response = await Axios.get("/locations/");
  return response.data;
};

export const getParties = async () => {
  const response = await Axios.get("/parties/");
  return response.data;
};

export const addLocation = async (formData) => {
  const response = await Axios.post("/locations/", formData);
  return response.data;
};

export const addParty = async (formData) => {
  const response = await Axios.post("/parties/", formData);
  return response.data;
};

export const editLocation = async (id, formData) => {
  const response = await Axios.put(`/locations/edit/${id}`, formData);
  return response.data;
};

export const editParty = async (id, formData) => {
  const response = await Axios.put(`/parties/edit/${id}`, formData);
  return response.data;
};

export const deleteLocation = async (id) => {
  const response = await Axios.delete(`/locations/delete/${id}`);
  return response.data;
};

export const deleteParty = async (id) => {
  const response = await Axios.delete(`/parties/delete/${id}`);
  return response.data;
};

export const getInOutPartEntries = async (partId) => {
  const response = await Axios.get(
    `/inventory/history/${partId}/?page=1&per_page=50`
  );
  return response.data;
};
